<script>
    import { writable } from "svelte/store";
    import AlertType from "../../Alerts/AlertType";
    import AlertTypeDescriptions from "../../Alerts/AlertTypeDescriptions";
    import LayerListSwitch from "../LayerList/LayerListSwitch.svelte";
    import AlertTypeSubcategorySwitch from "./AlertTypeSubcategorySwitch.svelte";

    // TODO: could be strongly typed.
    // type: AlertsStore._filterType
    export let alertType = AlertType.NONE;

    export let filterData = {
		visible: writable(false),
		exists: writable(false),
		subcategories: writable([])
	};
    export let onMainToggle = (event) => {};
    export let onSubToggle = (event) => {};

    let enabled = filterData.exists;
    let subcategories = filterData.subcategories;
    let visible = filterData.visible;
    let lastUpdated = filterData.lastUpdated;

    let countNamed = filterData.countCategoriesWithName();
    $: {
        $subcategories;
        countNamed = filterData.countCategoriesWithName();
    }

</script>


<LayerListSwitch
    label={AlertTypeDescriptions[alertType]}
    shortcode={alertType}
    data-alerttype={alertType}
    disabled={!$enabled}
    on:change={onMainToggle}
    bind:checked={$visible}
    visibleSwitch={countNamed !== 1}
    />

{#if countNamed >= 1}
    {#each $subcategories as cat}
       <AlertTypeSubcategorySwitch alertType={alertType} on:change={onSubToggle} typeData={filterData} categoryData={cat} />
    {/each}
{/if}